import Ensaio from "../models/ensaiosModel";

import { IService } from "./base/iService";

export default class EnsaioService extends IService<Ensaio> {
    constructor() {
        super("Ensaio");
    }
}